import script from "./CentralDaCoordenacao.vue?vue&type=script&setup=true&lang=js"
export * from "./CentralDaCoordenacao.vue?vue&type=script&setup=true&lang=js"

import "./CentralDaCoordenacao.vue?vue&type=style&index=0&id=78ed2478&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ed2478"]])

export default __exports__